
import Vue from "vue";
import { mask } from "vue-the-mask";
import store from "@/store";

export default Vue.extend({
  name: "Personal",

  directives: { mask },

  data: () => ({
    user: null as any,
    credentials: store.getters["authentication/credentials"],
    document: { title: "", document: null } as any,
    dialog: false as boolean,
    loading: false as boolean,
    errorMessages: {} as any,
    selects: {
      states: [] as Array<any>,
      genders: [
        {
          value: "m",
          text: "M",
        },
        {
          value: "f",
          text: "F",
        },
      ] as Array<any>,
      work_positions: [] as Array<any>,
      departments: [] as Array<any>,
      branches: [] as Array<any>,
    },
    model: {} as any,
    menu: false as boolean,
  }),

  computed: {
    userInfo() {
      return this.$store.getters["authentication/credentials"]?.user;
    },
  },

  async beforeMount() {
    await this.getData();
  },

  methods: {
    async getData() {
      try {
        // this.user = await this.$API.users().profile(this.userInfo.id);
        // this.selects.work_positions = await this.$API
        //   .profile()
        //   .getWorkPositionsList();
        // this.selects.departments = await this.$API
        //   .profile()
        //   .getDepartmentsList();
        // this.selects.branches = await this.$API.profile().getBranchesList();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    save(date: string) {
      (this.$refs.menu as any).save(date);
    },
  },
});
